// extracted by mini-css-extract-plugin
export var layoutContainer = "_bl-0";
export var layoutContainerNoRounding = "_bl-6";
export var layoutContainerOpen = "_bl-5";
export var layoutContainerResizing = "_bl-1";
export var mainContent = "_bl-2";
export var resizeDivider = "_bl-3";
export var slidePanel = "_bl-4";